import { render, staticRenderFns } from "./TemplateTile.vue?vue&type=template&id=4b2285c2&"
import script from "./TemplateTile.vue?vue&type=script&lang=js&"
export * from "./TemplateTile.vue?vue&type=script&lang=js&"
import style0 from "./TemplateTile.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports